import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import css from './metricCards.css';
import { useFetchTableData } from './hooks';
import { getAdminModeEnabled } from '../selectors/user';
import { parseMetricCards } from '../utils/metricCards';
import { calculateSecondPeriod } from '../utils/dateUtils';
import { REPORT_TYPES } from './consts';
import MetricCard from './MetricCard';

function MetricCardsWidget({
    dispatchWidgetVersions,
    dispatchWidgetsLoading,
    forceRefreshCounter = 0,
    dashboardId,
    widget,
    globalFilters = [],
    startDate,
    endDate,
    updatingGraphQL = false,
    displayUnenriched = false,
}) {
    const { startDate2, endDate2 } = calculateSecondPeriod(startDate, endDate);
    const isAdminMode = useSelector(state => getAdminModeEnabled(state));

    const [isLoading, tableData] = useFetchTableData(
        dashboardId,
        widget.gridParams.i,
        widget.query,
        globalFilters,
        startDate,
        endDate,
        startDate2,
        endDate2,
        REPORT_TYPES.REPORT,
        dispatchWidgetVersions,
        dispatchWidgetsLoading,
        true,
        widget.dataType,
        displayUnenriched,
        updatingGraphQL,
        forceRefreshCounter
    );

    const parsedMetricCards = parseMetricCards(isLoading, tableData, startDate, endDate);

    return (
        <>
            {isAdminMode && (
                <>
                    <div>
                        <b>startDate:</b> {startDate} <b>endDate:</b> {endDate}
                    </div>
                    <div>
                        <b>startDate2:</b> {startDate2} <b>endDate2:</b> {endDate2}
                    </div>
                </>
            )}
            <div className={css.metricCardsContainer}>
                {parsedMetricCards.map(cardProps => (
                    <MetricCard
                        {...cardProps}
                        key={cardProps.displayName}
                        isLoading={isLoading}
                        isAdminMode={isAdminMode}
                    />
                ))}
            </div>
        </>
    );
}

MetricCardsWidget.propTypes = {
    dispatchWidgetVersions: PropTypes.func.isRequired,
    dispatchWidgetsLoading: PropTypes.func.isRequired,
    dashboardId: PropTypes.string.isRequired,
    widget: PropTypes.shape({
        name: PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        type: PropTypes.oneOf(['table', 'pivot', 'metricCards']).isRequired,
        query: PropTypes.shape({
            dimensions: PropTypes.arrayOf(PropTypes.string),
            metrics: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        options: PropTypes.shape({
            rows: PropTypes.arrayOf(PropTypes.string),
            columns: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
    }).isRequired,
    globalFilters: PropTypes.arrayOf(
        PropTypes.shape({
            field: PropTypes.string.isRequired,
            operator: PropTypes.oneOf(['in', 'not in']).isRequired,
            values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
        })
    ),
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    updatingGraphQL: PropTypes.bool,
    forceRefreshCounter: PropTypes.number,
    displayUnenriched: PropTypes.bool,
};

export default memo(MetricCardsWidget);
